import { useMemo, useRef } from "react"
import { useApiWithAuth } from "../../hooks/useAuth.js"
import { createCoursesApi, type CoursesApi, type RequestFn } from "./api.js"

/** Stable CoursesApi bound to the authenticated fetch (apiCallWithAuth changes every render). */
export function useCoursesApi(): CoursesApi {
  const { apiCallWithAuth } = useApiWithAuth()
  const requestRef = useRef<RequestFn>(apiCallWithAuth)
  requestRef.current = apiCallWithAuth
  return useMemo(() => createCoursesApi((path, init) => requestRef.current(path, init)), [])
}
